import {
    styled,
    Text,
    TextTag,
    TokenTextAppearance,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'

const ModelTitle = styled(Text)`
    text-decoration: none;

    strong {
        font-weight: bold;
    }
`

interface ModelNameProps {
    model: string
    bigger: boolean
    tag: TextTag
    color: TokenTextColor
}

export function ModelName(props: ModelNameProps): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')

    return (
        <>
            {props.model.includes(t('simulation.new_1')) ||
            props.model.includes(t('simulation.new_2')) ? (
                <ModelTitle
                    tag={props.tag}
                    appearance={
                        !props.bigger
                            ? TokenTextAppearance.headline300
                            : TokenTextAppearance.headline400
                    }
                    color={props.color}
                >
                    <span>{props.model.slice(0, 5)}</span>{' '}
                    <strong>{props.model.slice(6)}</strong>
                </ModelTitle>
            ) : (
                <ModelTitle
                    tag={props.tag}
                    appearance={
                        !props.bigger
                            ? TokenTextAppearance.headline300
                            : TokenTextAppearance.headline400
                    }
                    color={props.color}
                    bold
                >
                    {props.model}
                </ModelTitle>
            )}
        </>
    )
}
